import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // add authorization header with basic auth credentials if available
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    const currentAdmin = JSON.parse(sessionStorage.getItem('currentAdmin'));
    if (currentUser && currentUser.authdata) {
        request = request.clone({
            setHeaders: {
                Authorization: `Basic ${currentUser.authdata}`
            }
        });
    } else if (currentAdmin && currentAdmin.authdata) {
      request = request.clone({
          setHeaders: {
              Authorization: `Basic ${currentAdmin.authdata}`
          }
      });
    }
    return next.handle(request);
  }
}
